import { fmtUtcS } from '../lib/format';

export function Stamp({ at, via }: { at?: Date | undefined; via?: string | undefined }) {
  return <p className="stamp">updated {fmtUtcS(at ?? new Date())}{via ? ` (${via})` : ''}</p>;
}
